import * as React from "react";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {STATE_CONFIGURATION_FILTERS} from "../constants/EnelxRecoil";
import {
    ID_FILTER_CONFIGURATION_DEALERS,
    ID_FILTER_CONFIGURATION_LEGAL_ENTITIES
} from "../constants/EnelxFilters";
import * as Yup from "yup";
import AdvancedFilter from "../../../component/AdvancedFilter";
import {addFilter, getFilterValue, renderMultiSelect} from "../../../utils/FilterUtils";
import {GlobalContext} from "../../../../../util/state/GlobalContextProvider";

function ConfigurationFilter() {
    const {t: tg} = useTranslation("translation");

    // Use Context
    const {
        globalData: {user},
    } = React.useContext(GlobalContext);

    const legalEntityOptions: any[] = user.legalEntities
        ?.filter((x: any) => x.name.toLowerCase() !== "all")
        .map((x: any) => ({
            value: x.name,
            label: tg(`legalEntities.${x.name}`),
        }));

    const dealerOptions: any[] = user.dealers
        ?.filter((x: any) => x.name.toLowerCase() !== "all")
        .map((x: any) => ({
            value: x.name,
            label: tg(`dealers.${x.name}`),
        }));

    const setFilters = useSetRecoilState(STATE_CONFIGURATION_FILTERS);
    const filterDefs = useRecoilValue(STATE_CONFIGURATION_FILTERS);
    const [dealers, setDealers] = useState<any[]>(dealerOptions);

    const schema = Yup.object().shape({
        dealers: Yup.array(),
        legalEntities: Yup.array().min(1, tg('validation.selectAtLeastOne')),
    });

    const defaultValues = {
        legalEntities:
            getFilterValue(ID_FILTER_CONFIGURATION_LEGAL_ENTITIES, filterDefs) || legalEntityOptions.map((x: any) => x.value),
        dealers: getFilterValue(ID_FILTER_CONFIGURATION_DEALERS, filterDefs) || [],
    };

    const fields = {
        legalEntities: renderMultiSelect(
            tg("shared.legalEntities"),
            legalEntityOptions,
            "legalEntities",
            legalEntityOptions.length <= 1,
            (value: any, setValue: any) => {
                setValue('dealers', []);
                let dealers = user?.dealers
                    ?.filter(
                        (x: any) =>
                            value?.length > 0 &&
                            x.legalEntities.some((e: any) => value.includes(e.name)) &&
                            x.name.toLowerCase() !== "all"
                    )
                    .map((x: any) => {
                        return {
                            label: tg(`dealers.${x.name}`),
                            value: x.name,
                        };
                    });
                setDealers(dealers);
            }
        ),
        dealers: renderMultiSelect(tg("shared.dealers"), dealers, "dealers", dealerOptions.length <= 1)
    };

    const submit = (data: any) => {
        addFilter(setFilters, ID_FILTER_CONFIGURATION_LEGAL_ENTITIES, data.legalEntities);
        addFilter(setFilters, ID_FILTER_CONFIGURATION_DEALERS, data.dealers);
    }

    const reset = () => {
        setFilters([]);
        setDealers(dealerOptions);
    }

    return (
        <AdvancedFilter schema={schema} mainFields={fields} defaultValues={defaultValues}
                        onSubmit={submit}
                        onReset={reset}
        />
    )
}

export default ConfigurationFilter;